<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Divorce Verification</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row row wrap>
            <v-col>
                <v-card>
                    <v-form v-model="formValid" ref="divorceVerForm">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <h4>Spouse 1</h4>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="First Name" v-model="divorceVerificationDto.firstName" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Middle Name" v-model="divorceVerificationDto.middleName" :persistent-hint="true" hint="Optional"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Last Name" v-model="divorceVerificationDto.lastName" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Birthdate" validate-on-blur type="date" v-model="divorceVerificationDto.dateOfBirth"
                                                  :rules="dobRules" persistent-hint :hint="divorceVerificationDto.dateOfBirth2 ? 'Optional' : ''">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <h4>Spouse 2</h4>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="First Name" v-model="divorceVerificationDto.firstName2" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Middle Name" v-model="divorceVerificationDto.middleName2" :persistent-hint="true" hint="Optional"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Last Name" v-model="divorceVerificationDto.lastName2" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Birthdate" validate-on-blur type="date" v-model="divorceVerificationDto.dateOfBirth2"
                                                  :rules="dobRules2" persistent-hint :hint="divorceVerificationDto.dateOfBirth ? 'Optional' : ''">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="Year Filed" persistent-hint hint="Optional" type="int" v-model="intYear">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <!--<v-select label="Reason for Verification" v-model="divorceVerificationDto.verificationReason"
                                        required :rules="requiredRule"
                                        :items="reasons">
                                    </v-select>-->
                                    <b>This verification is for government use only. Please enter in some information related to your request (Employee ID, Request ID, etc.)</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Additional Information" v-model="verificationReasonExtraInfo" :rules="requiredRule" required></v-text-field>
                                </v-col>
                            </v-row>
                            <div v-if="errors.length > 0">
                                <v-row  v-for="error in errors" :key="error">
                                    <b style="color:red">{{error}}</b>
                                </v-row>
                            </div>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn color="secondary" :disabled="isLoading || !formValid" @click="sendDivorceVerification">
                                        SUBMIT
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <div v-if="!!response && response.matchedRecords.length === 1">
            <v-row>
                <v-col>
                    <v-icon color="green">mdi-check-circle</v-icon>
                    <label>  Matched!</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table
                        :items="response.matchedRecords"
                        :headers="headers"
                        item-key="divorceId">
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="12">
                    If you would like a complete abstract for this request please contact VSS.
                </v-col>
                <v-col cols="12" v-show="abstractRequested">
                    An abstract has been requested, once approved you will see it in your inbox.
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2">
                    <v-btn @click="contactVSSForAbstract" :disabled="abstractRequested">Request Abstract</v-btn>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="printVerification" :disabled="isPrinting">Print</v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length > 1">
            <v-row>
                <v-col>
                    <v-icon color="yellow">mdi-help-circle</v-icon>
                    <label>  Potential Matches</label>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6">
                    There is more than one match for this request. Please contact VSS.
                </v-col>
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length === 0">
            <v-row>
                <v-col>
                    <v-icon color="red">mdi-close-circle</v-icon>
                    <label>  Not Verified</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    If you believe this to be an error you may contact VSS for a more refined search.
                </v-col>
            </v-row>
        </div>
        <contact-vss :operationType="operationType" :requestId="requestId" :modType="30" :numMatches="numberOfMatches"></contact-vss>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService'
import verificationService from '@/services/verificationService'
import mediaService from '@/services/mediaService'
import ContactVss from '../components/ContactVss.vue'

export default {
    components: {
        ContactVss
    },
    data: () => {
        return {
            isLoading: false,
            isPrinting: false,
            contact: false,
            abstractRequested: false,
            intYear: '',
            divorceVerificationDto: {
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: null,
                firstName2: '',
                middleName2: '',
                lastName2: '',
                dateOfBirth2: null,
                recordYear: null,
                matched: null,
                verificationReason: ''
            },
            verificationReasonExtraInfo: '',
            headers: [
                { text: 'First Name 1', value: 'firstName' },
                { text: 'Middle Name 1', value: 'middleName' },
                { text: 'Last Name 1', value: 'lastName' },
                { text: 'Date of Birth 1', value: 'dateOfBirth' },
                { text: 'First Name 2', value: 'firstName2' },
                { text: 'Middle Name 2', value: 'middleName2' },
                { text: 'Last Name 2', value: 'lastName2' },
                { text: 'Date of Birth 2', value: 'dateOfBirth2' },
                { text: 'Decree Date', value: 'decreeDate' },
                { text: 'Divorce Filed Date', value: 'dateFiled' }
            ],
            reasons: [ 'Reason 1' ],
            menu: false,
            verificationSent: false,
            requiredRule: [v => !!v || 'Required', v => !v || v.trim() !== '' || 'Invalid Input'],
            requiredYearRule: [v => !!v || 'Required', v => v > 1800 || 'Must be greater than 1800', v => v < 2200 || 'Must be less than 2200'],
            formValid: false,
            response: '',
            numberOfMatches: null,
            requestId: 0,
            errors: [],
            operationType: mailService.OperationEnum.Verification
        }
    },
    mounted () {
        this.$watch('divorceVerificationDto.dateOfBirth', () => {
            this.$refs.divorceVerForm.validate()
        })
        this.$watch('divorceVerificationDto.dateOfBirth2', () => {
            this.$refs.divorceVerForm.validate()
        })
    },
    computed: {
        dobRules () {
            return [
                (v) => {
                    if (!this.divorceVerificationDto.dateOfBirth2 && !v) {
                        return 'Minimum of one DOB is required.'
                    }
                    return true
                }
            ]
        },
        dobRules2 () {
            return [
                (v) => {
                    if (!this.divorceVerificationDto.dateOfBirth && !v) {
                        return 'Minimum of one DOB is required.'
                    }
                    return true
                }
            ]
        }
    },
    methods: {
        sendDivorceVerification () {
            this.errors = []
            this.$refs.divorceVerForm.validate()
            if (this.formValid) {
                this.isLoading = true
                this.divorceVerificationDto.verificationReason += ' ' + this.verificationReasonExtraInfo
                if (this.intYear && this.intYear.length > 0) {
                    this.divorceVerificationDto.recordYear = new Date(this.intYear, 0, 1)
                } else {
                    this.divorceVerificationDto.recordYear = null
                }
                verificationService.divorceVerification(this.$http, this.divorceVerificationDto).then(result => {
                    if (result.data && !result.data.errorMessages) {
                        this.response = result.data
                        this.numberOfMatches = this.response.matchedRecords.length
                        this.requestId = result.data.requestId
                        if (this.numberOfMatches > 0) {
                            this.$refs.divorceVerForm.reset()
                            this.resetDto()
                        }
                    } else {
                        this.errors = result.data.errorMessages
                    }
                    this.verificationSent = true
                    this.isLoading = false
                })
            }
        },
        contactVSSForAbstract () {
            verificationService.verificationRequestAbstract(this.$http, this.requestId)
            this.abstractRequested = true
        },
        printVerification () {
            this.isPrinting = true
            verificationService.verificationPrint(this.$http, this.requestId).then(response => {
                mediaService.fileToDownload(response, 'divorceVerification_request' + this.requestId + '.pdf')
                this.isPrinting = false
            })
        },
        resetDto () {
            this.divorceVerificationDto = {
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: null,
                firstName2: '',
                middleName2: '',
                lastName2: '',
                dateOfBirth2: null,
                recordYear: null,
                matched: null,
                verificationReason: ''
            }
        }
    }
}
</script>
